import { render, staticRenderFns } from "./ContributionMetadata.vue?vue&type=template&id=f45e8890"
import script from "./ContributionMetadata.vue?vue&type=script&lang=js"
export * from "./ContributionMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports